import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';

import { PageLoaderService, StorageService } from '@Workspace/services';
import { AuthService } from '@Workspace/auth';

import { Constants } from '@Workspace/common';

@Injectable()
export class CampaignGuard  {
    constructor(
        private authService: AuthService,
        private storageService: StorageService,
        private router: Router,
    ) { }

    private route: Route;

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        return this.canActivatePage();
    }

    private async canActivatePage(): Promise<boolean> {
        if (this.authService.isLogged) {
            return true;

        } else {
            this.storageService.set(
                Constants.LAST_URL_KEY,
                window.location.hash.substr(2)
            );

            this.router.navigate(['/sign-in']);
            return false;
        }
    }
}
